import { AMC_CATEGORY_LIST_CATEGORY_DATA, AMC_CATEGORY_LIST_CATEGORY_ERROR, AMC_CATEGORY_LIST_CATEGORY_HIDE_ERROR, AMC_CATEGORY_LIST_CATEGORY_START_LOADER, AMC_CATEGORY_LIST_CATEGORY_STOP_LOADER } from "../interface/iAmcCategoryListCategory";
const initialState = {
    data: [],
    errorData: { error: null, isOpen: false },
    loader: false,
};
const amcCategoryListCategoryReducer = (state = initialState, action) => {
    switch (action.type) {
        case AMC_CATEGORY_LIST_CATEGORY_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case AMC_CATEGORY_LIST_CATEGORY_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case AMC_CATEGORY_LIST_CATEGORY_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case AMC_CATEGORY_LIST_CATEGORY_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case AMC_CATEGORY_LIST_CATEGORY_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default amcCategoryListCategoryReducer;
